<template>
  <div>
    <SettingsNotifications
      client_name="MID"
      :notification_type_options="notification_type_options"
      :notification_channel_options="notification_channel_options"
      :users_options="users_options"
    />
  </div>
</template>

<script>
import SettingsNotifications from "@/components/settings/Notifications.vue";

export default {
  name: "MIDSettingsNotifications",
  components: { SettingsNotifications },
  data() {
    return {
      locations: [
        { text: "ZOOM ONLINE", id: "ZOOM ONLINE" },
        { text: "New location", id: "on_site" },
      ],
      notification_type_options: [
        {
          id: "new_event",
          label: "New event",
          customLabel: "New event",
        },
      ],
      notification_channel_options: [
        {
          id: "sms",
          label: "SMS",
        },
        {
          id: "email",
          label: "Email",
        },
        {
          id: "platform",
          label: "Platform notification",
        },
      ],
      users_options: [
        {
          id: "admin",
          label: "Admin",
          children: [{
            id:"user1",
            label:"User 1",
            customLabel:"Admin, User 1"
          }],
        },
        {
          id: "call_center",
          label: "Call center",
          children: [],
        },
      ],
      // notification_types_options:[{
      //             id: 'registrations',
      //             label: 'Registrations',
      //             children: [ {
      //               id: 'new_retailer',
      //               label: 'New retailer',
      //               customLabel: 'Registrations, New retailer'
      //             }, {
      //               id: 'new_deliverer',
      //               label: 'New deliverer',
      //               customLabel: 'Registrations, New deliverer'
      //             } ],
      //           }, {
      //             id: 'service_delivery',
      //             label: 'Service Delivery',
      //              children: [ {
      //               id: 'new_order',
      //               label: 'New order',
      //               customLabel: 'Service Delivery, New order'
      //             }, {
      //               id: 'order_completed',
      //               label: 'Order completed',
      //               customLabel: 'Service Delivery, Order completed'
      //             }, {
      //               id: 'collection_delay',
      //               label: 'Collection delay',
      //               customLabel: 'Service Delivery, Collection delay'
      //             }, {
      //               id: 'external_store_fulfillment',
      //               label: 'External store fulfillment',
      //               customLabel: 'Service Delivery, External store fulfillment'
      //             } ],
      //           }, {
      //             id: 'payments',
      //             label: 'Payments',
      //               customLabel: 'Payments'
      //           }]
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/settings/Notifications.vue